module.exports = __webpack_public_path__ + "../resources/images/letsgo-airplane-bb2883d68bff8dced50c4aa62b993692.png";